import { MenuConfigService } from './../../../../core/_base/layout/services/menu-config.service';
import { MenuOptions } from './../../../../core/_base/layout/directives/menu.directive';
import { TranslocoService } from '@ngneat/transloco';
import { upperFirst } from 'lodash';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { HorMenuService } from './services/menu.service';
import { Subject } from 'rxjs';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import objectPath from 'object-path';
import { takeUntil, filter } from 'rxjs/operators';

@Component({
  selector: 'kt-horizontal-menu',
  templateUrl: './horizontal-menu.component.html',
  styleUrls: ['./horizontal-menu.component.scss'],
})
export class HorizontalMenuComponent implements OnInit, OnDestroy {
  menuOptions: MenuOptions = {
    submenu: {
      desktop: 'dropdown',
      tablet: 'accordion',
      mobile: 'accordion',
    },
    accordion: {
      slideSpeed: 200, // accordion toggle slide speed in milliseconds
      expandAll: false, // allow having multiple expanded accordions in the menu
    },
  };

  private unsubscribe: Subject<any> = new Subject<any>();
  private menuItems: any[] = [];

  constructor(
    private transloco: TranslocoService,
    private router: Router,
    private route: ActivatedRoute,
    private menuConfigService: MenuConfigService,
    public menuService: HorMenuService,
  ) {}

  ngOnInit() {
    this.menuConfigService.onConfigUpdated$.subscribe((menu) => {
      const menuItems: any[] = objectPath.get(menu, 'aside.items');
      this.menuItems = menuItems;
      this.setMenu(this.router.url);
    });

    this.router.events
      .pipe(
        takeUntil(this.unsubscribe),
        filter((e) => e instanceof NavigationEnd),
      )
      .subscribe((e: NavigationEnd) => this.setMenu(e.urlAfterRedirects));
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  getTitle(item: any): string {
    const lang = upperFirst(this.transloco.getActiveLang());

    if (item.translate) {
      return this.transloco.translate(item.translate);
    }

    return item[`title${lang}`] || item.title;
  }

  getPermissions(permissions: any, admin = true): string[] {
    let childPermissions = [];

    const result = permissions.map((permission: any) => {
      if (permission.children) {
        childPermissions = childPermissions.concat(this.getPermissions(permission.children, false));
      }

      return permission.name;
    });

    return admin ? ['admin'].concat(result) : result;
  }

  private setMenu(currentUrl: string) {
    const parent = this.menuItems.find((item: any) => {
      if (!item.submenu || item.submenu.length === 0) {
        return false;
      }

      return item.submenu.some((child: any) => child.page === currentUrl);
    });

    if (parent) {
      this.menuService.setMenu(parent.submenu);
    } else {
      this.menuService.setMenu([]);
    }
  }
}
